var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#347af0;stroke:#707070;opacity:0;}.b{fill:#438afb;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899 -219)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(899 219)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(903 146)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.606 82.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M339.392,148.45l5.394,3.41V144.9Z",
    transform: "translate(-339.392 -144.896)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 82.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,144.9v6.964l5.394-3.41Z",
    transform: "translate(0 -144.896)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.03 80)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.93,80h-14a.988.988,0,0,0-.97.851L8.93,86.1l7.97-5.251A.988.988,0,0,0,15.93,80Z",
    transform: "translate(-0.96 -80)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.032 86.185)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.682,277.921l-1.415.932a.5.5,0,0,1-.55,0L7.3,277.92l-6.278,3.971a.986.986,0,0,0,.968.844h14a.986.986,0,0,0,.968-.844Z",
    transform: "translate(-1.024 -277.92)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.749bd95bf6ace60620142757fb3f4d84.svg";
export { ForwardRef as ReactComponent };